import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

/*Import UTILS */
import { renderHighlightedPath } from "./utils/renderHighlightedPath";

/*Import podkomponente */
import ProgramsList from "./programs/ProgramsList";

/*Import API */
import {
  iskanjeProgramStrukturaNivo1,
  prviNivoProgramiAPI,
} from "../listOfApi";
import { fetchGET } from "../apiHelper";

/* React-Bootstrap component */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

/*import React-icons */
import { AiOutlineExclamationCircle } from "react-icons/ai";

const Programs = ({ role }) => {
  const MIN_SEARCH_LENGTH = 3;
  const navigate = useNavigate();

  const [programs, setPrograms] = useState([]);
  const [filteredPrograms, setFilteredPrograms] = useState([]);
  const [programsLoaded, setProgramsLoaded] = useState(false);
  const [searchProgram, setSearchProgram] = useState("");
  const [showActive, setShowActive] = useState(false);
  const [searchProgramDebounced, setSearchProgramDebounced] = useState("");
  const [searchStructureResults, setSearchStructureResults] = useState([]);

  useEffect(() => {
    fetchGET(prviNivoProgramiAPI).then((programi) => {
      if (programi !== 0) {
        setPrograms(programi);
        setFilteredPrograms(programi);
        setProgramsLoaded(true);
      }
    });
  }, []);

  /*Filtriranje seznama ki se prikaže glede na status checkboxa "Aktiven" */
  useEffect(() => {
    if (showActive) {
      const activePrograms = programs.filter((program) => program.aktiven);
      setFilteredPrograms(activePrograms);
    } else {
      setFilteredPrograms(programs);
    }
  }, [showActive]);

  /*Debouncing iskanja v strukturi programa, da se zahteva po iskanju sproži šele po 300ms od zadnje spremembe v iskalnem polju */
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setSearchProgramDebounced(searchProgram.trim());
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [searchProgram]);

  /*Iskanje v strukturi programa na podlagi iskalnega izraza, ki se sproži ob spremembi debounced iskalnega izraza */
  useEffect(() => {
    let isActive = true;

    if (searchProgramDebounced.length < MIN_SEARCH_LENGTH) {
      setSearchStructureResults([]);
      return () => {
        isActive = false;
      };
    }

    const endpoint = `${iskanjeProgramStrukturaNivo1}?query=${encodeURIComponent(
      searchProgramDebounced,
    )}`;

    fetchGET(endpoint).then((response) => {
      if (!isActive) {
        return;
      }

      if (response === 0 || !Array.isArray(response)) {
        setSearchStructureResults([]);
        return;
      }

      setSearchStructureResults(response);
    });

    return () => {
      isActive = false;
    };
  }, [MIN_SEARCH_LENGTH, searchProgramDebounced]);

  // Klik na enega izmed rezultatov iskanja v strukturi programa nas preusmeri na stran s podrobnostmi o tem programu (struktura)
  const handleSearchResultClick = (rootID) => {
    setSearchStructureResults([]);
    navigate({
      pathname: `/Programi/Struktura/${rootID}`,
      search: `?search=${encodeURIComponent(searchProgram)}`,
    });
  };

  /*Pokaže dropdown z rezultati iskanja v strukturi programa, če je iskalni izraz dovolj dolg in so na voljo rezultati */
  const showSearchStructureDropdown =
    searchProgram.trim().length >= MIN_SEARCH_LENGTH &&
    searchStructureResults.length > 0;

  const isSearching = searchProgram.trim().length >= MIN_SEARCH_LENGTH;

  return (
    <Container fluid>
      {(role.programi === 1 || role.programi === 2) && (
        <>
          <Row>
            <Col className="main-header font-weight-bold">Programi</Col>
          </Row>
          <Row className="mb-2">
            <Col className="header-divider">
              <hr />
            </Col>
          </Row>
          <Row className="mb-2 align-items-center">
            <Col lg={5} md={8}>
              <Form.Control
                name="iskalnik"
                type="text"
                value={searchProgram}
                onChange={(e) => setSearchProgram(e.target.value)}
                placeholder="Poišči program po nazivu ali poti..."
              />
            </Col>
            <Col>
              <Form.Check
                name="aktiven"
                type="checkbox"
                checked={showActive}
                onChange={() => setShowActive(!showActive)}
                label="Aktiven"
              />
            </Col>
            <Col>
              <div className="float-end">
                {role.programi === 2 && (
                  <Link
                    className="programs-button-add-text"
                    to={`/Programi/DodajProgram/`}
                  >
                    <Button variant="outline-primary">Dodaj program</Button>
                  </Link>
                )}
              </div>
            </Col>
          </Row>

          {showSearchStructureDropdown && (
            <Row className="mb-2">
              <Col>
                <div className="programs-page-search-results">
                  {searchStructureResults.map((result) => (
                    <button
                      key={`${result.objectID}-${result.path}`}
                      type="button"
                      className="programs-page-search-results__path"
                      onClick={() => handleSearchResultClick(result.rootID)}
                    >
                      {renderHighlightedPath(result.path, searchProgram, 3)}
                    </button>
                  ))}
                </div>
              </Col>
            </Row>
          )}

          <div>
            {/* Komponenta ProgramsList za prikaz seznama programov */}
            {programsLoaded && !isSearching && (
              <ProgramsList programs={filteredPrograms} />
            )}
          </div>

          {!programsLoaded && (
            <Row className="mt-3">
              <Col>
                <h5>
                  <span className="me-3">
                    <AiOutlineExclamationCircle />
                  </span>
                  Nalaganje programov...
                </h5>
              </Col>
            </Row>
          )}
        </>
      )}
    </Container>
  );
};

export default Programs;
